import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion';
import axiosInstance from '../../utils/axios/axiosConfig';
import { toast } from 'react-toastify';
import { Loading } from '../../components';
import { DeleteModal } from '../../components';
import { useAccessChecker } from '../../utils/Functions/Authorization';
import { useTranslation } from 'react-i18next';
import { Download, Search, CirclePlus, ImageIcon, CornerDownRight, Trash2, ChevronDown, Pencil } from 'lucide-react'
import CategoryModal from './CategoryModal';
import ImportModal from './ImportModal';

function Categories() {
    const { t } = useTranslation();

    const { checkAccess } = useAccessChecker();

    const [categoryModal, setCategoryModal] = useState(false)
    const [CategoryId, setCategoryId] = useState(null)
    const [SubCategoryId, setSubCategoryId] = useState(null)

    const [categories, setCategories] = useState([])
    const [categoryToUpdate, setCategoryToUpdate] = useState(null)
    const [expandedCategories, setExpandedCategories] = useState([])
    const [ImportCategoryModal, setImportCategoryModal] = useState(false)


    const [searchValue, setSearchValue] = useState(null)


    const [loading, setLoding] = useState(false)
    const [done, setDone] = useState(false)

    const [deleteModal, setDeleteModal] = useState(false)
    const [SubdeleteModal, setSubDeleteModal] = useState(false)



    useEffect(() => {
        getCategory()
    }, [CategoryId, done, searchValue])




    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const getCategory = async (page = 1) => {
        try {
            setLoding(true);
            const response = await axiosInstance.post(`/categories/search?page=${page}&per_page=10`, { searchValue });
            const responseData = response.data;

            if (responseData) {
                setCategories(responseData.data);
                setCurrentPage(responseData.current_page);
                setTotalPages(responseData.last_page);
            }
            setLoding(false);
        } catch (error) {
            toast.error(error.response.data.message);
            setLoding(false);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            getCategory(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            getCategory(currentPage - 1);
        }
    };


    const handelEditModal = (item) => {
        setCategoryToUpdate(item)
        setCategoryModal(true)
    }
    const toggleSubcategories = (categoryId) => {
        setExpandedCategories((prev) =>
            prev.includes(categoryId) ? prev.filter((id) => id !== categoryId) : [...prev, categoryId],
        )
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    }


    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="flex flex-col w-full h-full px-6 py-5 bg-neutral-50/80"
        >
            {loading && <Loading />}

            {/* Header */}
            <div className="flex lg:justify-between gap-3 lg:items-center flex-col lg:flex-row mb-6">
                <div className="flex flex-col items-start gap-1">

                    <h1 className="text-xl font-semibold text-neutral-900 dark:text-white">Categories</h1>
                    <p className="text-sm text-neutral-600 ">Manage categories here .</p>

                </div>
                <div className="flex flex-col lg:flex-row lg:items-center gap-3">
                    {/* Search */}
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" />
                        <input
                            onChange={(e) => setSearchValue(e.target.value)} value={searchValue}
                            type="text"
                            placeholder="Search categories..."
                            className="pl-10 pr-4 py-2 lg:w-64 w-full text-sm border border-neutral-200 dark:border-neutral-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-neutral-800 dark:text-white"
                        />
                    </div>

                    {/* Download CSV */}
                    <button onClick={() => setImportCategoryModal(true)} className="inline-flex items-center px-4 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-200 rounded-lg hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700">
                        <Download className="w-4 h-4 mr-2" />
                        Import Categories
                    </button>

                    {/* New User Button */}
                    {checkAccess("categories", "create") && (
                        <button
                            onClick={() => { setCategoryModal(true) }} className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#2B2B35] rounded-lg hover:bg-cyan-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            <CirclePlus className="w-4 h-4 mr-2" />
                            New Category
                        </button>
                    )}
                </div>
            </div>
            <section className=" w-full mx-auto">


                <div className="flex flex-col mt-4">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            <div className="overflow-hidden border border-neutral-200 dark:border-neutral-700 md:rounded-lg">
                                <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-700">
                                    <thead className="bg-neutral-50 h-14 dark:bg-neutral-800">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="px-12 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Image
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-12 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Name
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-12 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Slug
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Date
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-neutral-200 dark:divide-neutral-700 dark:bg-neutral-900">
                                        {categories.map((category) => (
                                            <React.Fragment key={category.id}>
                                                <tr className='h-16'>
                                                    <td className="px-12  text-sm text-start font-medium whitespace-nowrap">
                                                        <div>
                                                            {category.image ?
                                                                <img src={category.image || null} alt='image' className='h-12 w-12 rounded-full object-cover' />
                                                                :
                                                                <div className='h-12 w-12 rounded-full bg-neutral-100 flex justify-center items-center'> <ImageIcon className='text-neutral-400 h-5 w-5' /> </div>
                                                            }
                                                        </div>
                                                    </td>
                                                    <td className="px-12  text-sm text-start font-medium whitespace-nowrap">
                                                        <div>
                                                            <p className="text-sm font-normal text-neutral-600 dark:text-neutral-400">
                                                                {category.name}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className="px-12  text-sm text-start font-medium whitespace-nowrap">
                                                        <div>
                                                            <p className="text-sm font-normal text-neutral-600 dark:text-neutral-400">
                                                                {category.slug}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className="px-4  text-start text-sm whitespace-nowrap">
                                                        <div>
                                                            <p className="text-neutral-500 dark:text-neutral-400">
                                                                {formatDate(category.created_at)}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className="px-4  text-sm whitespace-nowrap">
                                                        <div className="flex justify-start items-center gap-3">
                                                            {checkAccess("categories", "delete") && (
                                                                <button
                                                                    onClick={() => {
                                                                        setCategoryId(category.id)
                                                                        setDeleteModal(true)
                                                                    }}
                                                                    className="flex justify-center hover:scale-110 transition-all duration-400 items-center  dark:bg-red-600 dark:bg-opacity-10 rounded-md hover:bg-neutral-200 text-neutral-500"
                                                                >
                                                                    <Trash2 size={16} />

                                                                </button>
                                                            )}
                                                            {checkAccess("categories", "update") && (
                                                                <button
                                                                    onClick={() => handelEditModal(category)}
                                                                    className="flex justify-center hover:scale-110 transition-all duration-400 items-center  dark:bg-green-600 dark:bg-opacity-10 rounded-md hover:bg-neutral-200 text-neutral-500"
                                                                >
                                                                    <Pencil size={16} />

                                                                </button>
                                                            )}
                                                            {category.subcategories && category.subcategories.length > 0 && (
                                                                <button
                                                                    onClick={() => toggleSubcategories(category.id)}
                                                                    className="flex justify-center hover:scale-110 transition-all duration-400 items-center  dark:bg-blue-600 dark:bg-opacity-10 rounded-md hover:bg-neutral-200 text-neutral-500"
                                                                >
                                                                    <ChevronDown size={16} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                                {expandedCategories.includes(category.id) &&
                                                    category.subcategories &&
                                                    category.subcategories.map((subcategory) => (
                                                        <tr key={subcategory.id} className="h-16 bg-neutral-50 dark:bg-neutral-800">
                                                            <td className="px-12 pt-2 text-sm flex items-center  gap-2 text-start font-medium whitespace-nowrap">
                                                                <span className="mr-2"><CornerDownRight className='h-4 w-4 text-neutral-500' /></span>

                                                                <div>
                                                                    {category.image ?
                                                                        <img src={subcategory.image || null} alt='image' className='h-12 w-12  rounded-full object-cover' />
                                                                        :
                                                                        <div className='h-12 w-12 rounded-full bg-neutral-100 flex justify-center items-center'> <ImageIcon className='text-neutral-400 h-5 w-5' /> </div>
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td className="px-12  text-sm font-medium whitespace-nowrap">
                                                                <div className="flex items-center">
                                                                    <p className="text-sm font-normal text-neutral-600 dark:text-neutral-400">
                                                                        {subcategory.name}
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td className="px-12  text-sm text-start font-medium whitespace-nowrap">
                                                                <div>
                                                                    <p className="text-sm font-normal text-neutral-600 dark:text-neutral-400">
                                                                        {subcategory.slug}
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td className="px-4  text-sm text-start whitespace-nowrap">
                                                                <div>
                                                                    <p className="text-neutral-500 dark:text-neutral-400">
                                                                        {formatDate(subcategory.created_at)}
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td className="px-4  text-sm whitespace-nowrap">
                                                                <div className="flex justify-start items-center gap-2">
                                                                    {checkAccess("categories", "delete") && (
                                                                        <button
                                                                            onClick={() => {
                                                                                setSubCategoryId(subcategory.id)
                                                                                setSubDeleteModal(true)
                                                                            }}
                                                                            className="flex justify-center hover:scale-110 transition-all duration-400 items-center p-2 dark:bg-red-600 dark:bg-opacity-10 rounded-md hover:bg-neutral-200 text-neutral-500"
                                                                        >
                                                                            <Trash2 size={16} />
                                                                        </button>
                                                                    )}
                                                                    {checkAccess("categories", "update") && (
                                                                        <button
                                                                            onClick={() => handelEditModal(subcategory)}
                                                                            className="flex justify-center hover:scale-110 transition-all duration-400 items-center p-2 0 rounded-md hover:bg-neutral-200 text-neutral-500"
                                                                        >
                                                                            <Pencil size={16} />

                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="mt-6 sm:flex sm:items-center sm:justify-between ">
                    <div className="text-sm text-neutral-500 dark:text-neutral-400">
                        Page <span className="font-medium text-neutral-700 dark:text-neutral-100">{currentPage} of {totalPages}</span>
                    </div>
                    <div className="flex items-center mt-4 gap-x-4 sm:mt-0">
                        <button
                            onClick={handlePrevious}
                            disabled={currentPage === 1}
                            className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-neutral-700 capitalize transition-colors duration-200 bg-white border rounded-md sm:w-auto gap-x-2 hover:bg-neutral-100 dark:bg-neutral-900 dark:text-neutral-200 dark:border-neutral-700 dark:hover:bg-neutral-800"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 rtl:-scale-x-100">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                            </svg>
                            <span>Previous</span>
                        </button>
                        <button
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                            className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-neutral-700 capitalize transition-colors duration-200 bg-white border rounded-md sm:w-auto gap-x-2 hover:bg-neutral-100 dark:bg-neutral-900 dark:text-neutral-200 dark:border-neutral-700 dark:hover:bg-neutral-800"
                        >
                            <span>Next</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 rtl:-scale-x-100">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                            </svg>
                        </button>
                    </div>
                </div>

            </section>



            <CategoryModal
                isOpen={categoryModal}
                onClose={() => { setCategoryModal(false) }}
                categories={categories}
                CategoryToUpdate={categoryToUpdate}
                setDone={setDone}
                done={done}
                setCategoryToUpdate={setCategoryToUpdate}
            />
            <ImportModal
                isOpen={ImportCategoryModal}
                onClose={() => setImportCategoryModal(false)}
                categories={categories}
                setDone={setDone}
                done={done}

            />




            <DeleteModal setDeleteId={setCategoryId} open={deleteModal} setOpen={setDeleteModal} DeleteId={CategoryId} Model='categories' setDone={setDone} setLoding={setLoding} done={done} />
            <DeleteModal setDeleteId={setSubCategoryId} open={SubdeleteModal} setOpen={setSubDeleteModal} DeleteId={SubCategoryId} Model='subcategories' setDone={setDone} setLoding={setLoding} done={done} />

        </motion.div >


    )
}

export default Categories